const storagePrefix = "billiard-erp:operation:";
const memoryKeys = new Map<string, string>();

function readSessionStorage(): Storage | null {
  if (typeof sessionStorage === "undefined") return null;
  try {
    return sessionStorage;
  } catch {
    return null;
  }
}

function claimOperationKey(operationId: string): string {
  const storage = readSessionStorage();
  try {
    const stored = storage?.getItem(`${storagePrefix}${operationId}`);
    if (stored) return stored;
  } catch {
    // The in-memory fallback still protects retries in the current page session.
  }
  const remembered = memoryKeys.get(operationId);
  if (remembered) return remembered;
  const key = crypto.randomUUID();
  memoryKeys.set(operationId, key);
  try {
    storage?.setItem(`${storagePrefix}${operationId}`, key);
  } catch {
    // Some hardened browser contexts deny sessionStorage.
  }
  return key;
}

function releaseOperationKey(operationId: string, expectedKey: string): void {
  if (memoryKeys.get(operationId) === expectedKey) memoryKeys.delete(operationId);
  const storage = readSessionStorage();
  try {
    if (storage?.getItem(`${storagePrefix}${operationId}`) === expectedKey) {
      storage.removeItem(`${storagePrefix}${operationId}`);
    }
  } catch {
    // The successful operation is already complete; storage cleanup is best effort.
  }
}

export async function runIdempotentOperation<T>(
  operationId: string,
  operation: (idempotencyKey: string) => Promise<T>,
): Promise<T> {
  const key = claimOperationKey(operationId);
  const result = await operation(key);
  releaseOperationKey(operationId, key);
  return result;
}
